import React from 'react';
import PushDown from './PushDown';
import TopNavbar from './TopNavbar';
import TransparentTopNavbar from './TopNavbar/TransparentTopNavbar';
import useIsMobile from 'hooks/useIsMobile';

interface NavbarProps {
  transparent?: boolean;
  nonFixedNavbar: boolean;
  showSearchInNavbar: boolean;
  subNavbar?: string;
  noMobileNavbar?: boolean;
  renderNavbarLinks?: (transparant: boolean) => React.ReactElement;
}

function Navbar({ transparent, nonFixedNavbar, showSearchInNavbar, subNavbar, noMobileNavbar, renderNavbarLinks }: NavbarProps) {
  const isMobile = useIsMobile();
  if (isMobile && noMobileNavbar) {
    return null;
  }
  return (
    <>
      {!transparent && !nonFixedNavbar &&
        <PushDown subNavbar={subNavbar} />
      }
      {transparent ?
        <TransparentTopNavbar
          showSearch={showSearchInNavbar}
          subNavbar={subNavbar}
          nonFixedNavbar={nonFixedNavbar}
          renderNavbarLinks={renderNavbarLinks}
        /> :
        <TopNavbar
          showSearch={showSearchInNavbar}
          transparent={false}
          subNavbar={subNavbar}
          nonFixedNavbar={nonFixedNavbar}
          renderNavbarLinks={renderNavbarLinks}
        />
      }
    </>
  );
}

export default Navbar;
